import React, { useState, useRef, useEffect } from "react";
import { postData } from '../../../../../ApiServices/ApiService';
import { ORG_CONFIGURATION_CONTACT_CENTER} from '../../../../../ApiServices/BaseURL';
import { logFrontendException } from '../../../../../Utils/Exception';
import { useTheme } from '../../../../../GlobalContext/GlobalContext';

const ContactCenterController =()=>{
    const [whatsappLoading, setWatsappLoading] = useState(false);
    const [whatsappError, setWatsappError] = useState('');
    const [whatsappList, setWhatsappList] = useState([]);
    const [emailLoading, setEmailLoading] = useState(false);
    const [emailError, setEmailError] = useState('');
    const [emailList, setEmailList] = useState([]);
    const [smsLoading, setSmsLoading] = useState(false);
    const [smsError, setSmsError] = useState('');
    const [smsList, setSmsList] = useState([]);
    const [listSummaryLoading, setListSummaryLoading] = useState(false);
    const [listSummaryError, setListSummaryError] = useState('');
    const [listSummaryList, setListSummaryList] = useState([]);
     const storedUserId = JSON.parse(localStorage.getItem("_userInfo_"))?.emp_id;
     const pageName = "ContactsCenterController";
     const { setIsLoginPopup } = useTheme();

     useEffect(() => {
        const storedUserInfo = JSON.parse(localStorage.getItem('whatsAppStatus'));

      if (storedUserInfo === 1) {
        fetchWhatappList();
      }
        fetchEmailList();
        fetchSMSList();
        fetchListSummary();
  }, []);

    const fetchWhatappList = async () => {
    setWhatsappList([])
    setWatsappLoading(true);
    setWatsappError('')
    try {
      const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
      const payload = {
        "action_type": "whatsapp_contacts",
        "emp_id_auth": storedUserInfo?.emp_id,
      }
      const response = await postData(ORG_CONFIGURATION_CONTACT_CENTER, payload);
      const responseData = await response.json();


      if (response.status === 200 && responseData.status_code === 200) {
        if (responseData.message.toLowerCase() === "success") {
          if (responseData?.dataJ?.length > 0) {
            setWhatsappList(responseData?.dataJ || []);
            // setCurrentPage(1);
          } else {
            setWatsappError(responseData?.info || "Failed to fetch whatsapp list.");
            // ⛔️ Log exception to backend (User Id,Page Name,Method Name,Response/error)
            logFrontendException(storedUserId, pageName, "fetchWhatappList", responseData || '');

          }
        } else {
          setWatsappError(responseData?.info || "Failed to fetch  whatsapp list.");
          // ⛔️ Log exception to backend (User Id,Page Name,Method Name,Response/error)
          logFrontendException(storedUserId, pageName, "fetchWhatappList", responseData || '');
        }
      }else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
        setWatsappError('Unauthorized access. Your session may have expired. Please log in again.');
        setIsLoginPopup(true)
        // ⛔️ Log exception to backend (User Id,Page Name,Method Name,Response/error)
        logFrontendException(storedUserId, pageName, "fetchWhatappList", responseData || response || '');
               
        } else {
        setWatsappError(responseData?.info || "Failed to fetch  whatsapp list.");
        // ⛔️ Log exception to backend (User Id,Page Name,Method Name,Response/error)
        logFrontendException(storedUserId, pageName, "fetchWhatappList", responseData || response || '');
      }
    } catch (err) {
      setWatsappError("Network error. Please try again.");
      logFrontendException(storedUserId, pageName, "fetchWhatappList-catch", err || '');
    } finally {
      setWatsappLoading(false);
    }
  };

  const fetchEmailList = async () => {
    setEmailList([])
    setEmailLoading(true);
    setEmailError('')
    try {
      const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
      const payload = {
        "action_type": "email_contacts",
        "emp_id_auth": storedUserInfo?.emp_id,
      }
      const response = await postData(ORG_CONFIGURATION_CONTACT_CENTER, payload);
      const responseData = await response.json();


      if (response.status === 200 && responseData.status_code === 200) {
        if (responseData.message.toLowerCase() === "success") {
          if (responseData?.dataJ?.length > 0) {
            setEmailList(responseData?.dataJ || []);
            // setCurrentPage(1);
          } else {
            setEmailError(responseData?.info || "Failed to fetch email list.");
            // ⛔️ Log exception to backend (User Id,Page Name,Method Name,Response/error)
            logFrontendException(storedUserId, pageName, "fetchEmailList", responseData || '');

          }
        } else {
          setEmailError(responseData?.info || "Failed to fetch  email list.");
          // ⛔️ Log exception to backend (User Id,Page Name,Method Name,Response/error)
          logFrontendException(storedUserId, pageName, "fetchEmailList", responseData || '');
        }
      }else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
        setEmailError('Unauthorized access. Your session may have expired. Please log in again.');
        setIsLoginPopup(true)
        // ⛔️ Log exception to backend (User Id,Page Name,Method Name,Response/error)
        logFrontendException(storedUserId, pageName, "fetchEmailList", responseData || response || '');
               
        } else {
        setEmailError(responseData?.info || "Failed to fetch  email list.");
        // ⛔️ Log exception to backend (User Id,Page Name,Method Name,Response/error)
        logFrontendException(storedUserId, pageName, "fetchEmailList", responseData || response || '');
      }
    } catch (err) {
      setEmailError("Network error. Please try again.");
      logFrontendException(storedUserId, pageName, "fetchEmailList-catch", err || '');
    } finally {
      setEmailLoading(false);
    }
  };

  const fetchSMSList = async () => {
    setSmsList([])
    setSmsLoading(true);
    setSmsError('');
    try {
      const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
      const payload = {
        "action_type": "sms_contacts",
        "emp_id_auth": storedUserInfo?.emp_id,
      }
      const response = await postData(ORG_CONFIGURATION_CONTACT_CENTER, payload);
      const responseData = await response.json();


      if (response.status === 200 && responseData.status_code === 200) {
        if (responseData.message.toLowerCase() === "success") {
          if (responseData?.dataJ?.length > 0) {
            setSmsList(responseData?.dataJ || []);
            // setCurrentPage(1);
          } else {
            setSmsError(responseData?.info || "Failed to fetch SMS list.");
            // ⛔️ Log exception to backend (User Id,Page Name,Method Name,Response/error)
            logFrontendException(storedUserId, pageName, "fetchSMSList", responseData || '');

          }
        } else {
          setSmsError(responseData?.info || "Failed to fetch  SMS list.");
          // ⛔️ Log exception to backend (User Id,Page Name,Method Name,Response/error)
          logFrontendException(storedUserId, pageName, "fetchSMSList", responseData || '');
        }
      }else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
        setSmsError('Unauthorized access. Your session may have expired. Please log in again.');
        setIsLoginPopup(true)
        // ⛔️ Log exception to backend (User Id,Page Name,Method Name,Response/error)
        logFrontendException(storedUserId, pageName, "fetchSMSList", responseData || response || '');
               
        } else {
        setSmsError(responseData?.info || "Failed to fetch  SMS list.");
        // ⛔️ Log exception to backend (User Id,Page Name,Method Name,Response/error)
        logFrontendException(storedUserId, pageName, "fetchSMSList", responseData || response || '');
      }
    } catch (err) {
      setSmsError("Network error. Please try again.");
      logFrontendException(storedUserId, pageName, "fetchSMSList-catch", err || '');
    } finally {
      setSmsLoading(false);
    }
  };

  const fetchListSummary = async () => {
    setListSummaryList([])
    setListSummaryLoading(true);
    setListSummaryError('');
    try {
      const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
      const payload = {
        "action_type": "list_summary",
        "emp_id_auth": storedUserInfo?.emp_id,
      }
      const response = await postData(ORG_CONFIGURATION_CONTACT_CENTER, payload);
      const responseData = await response.json();


      if (response.status === 200 && responseData.status_code === 200) {
        if (responseData.message.toLowerCase() === "success") {
          if (responseData?.dataJ?.length > 0) {
            setListSummaryList(responseData?.dataJ || []);
            // setCurrentPage(1);
          } else {
            setListSummaryError(responseData?.info || "Failed to fetch SMS list.");
            // ⛔️ Log exception to backend (User Id,Page Name,Method Name,Response/error)
            logFrontendException(storedUserId, pageName, "fetchSMSList", responseData || '');

          }
        } else {
          setListSummaryError(responseData?.info || "Failed to fetch  SMS list.");
          // ⛔️ Log exception to backend (User Id,Page Name,Method Name,Response/error)
          logFrontendException(storedUserId, pageName, "fetchSMSList", responseData || '');
        }
      }else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
        setListSummaryError('Unauthorized access. Your session may have expired. Please log in again.');
        setIsLoginPopup(true)
        // ⛔️ Log exception to backend (User Id,Page Name,Method Name,Response/error)
        logFrontendException(storedUserId, pageName, "fetchSMSList", responseData || response || '');
               
        } else {
        setListSummaryError(responseData?.info || "Failed to fetch  SMS list.");
        // ⛔️ Log exception to backend (User Id,Page Name,Method Name,Response/error)
        logFrontendException(storedUserId, pageName, "fetchSMSList", responseData || response || '');
      }
    } catch (err) {
      setListSummaryError("Network error. Please try again.");
      logFrontendException(storedUserId, pageName, "fetchSMSList-catch", err || '');
    } finally {
      setListSummaryLoading(false);
    }
  };

  return{
    fetchWhatappList,
    whatsappLoading,
    whatsappList,
    whatsappError,
    setWatsappLoading,
    setWatsappError,
    setWhatsappList,

    setEmailError,
    emailError,
    setEmailList,
    emailList,
    emailLoading,
    setEmailLoading,
    fetchEmailList,

    setSmsError,
    smsError,
    setSmsList,
    smsList,
    setSmsLoading,
    smsLoading,
    fetchSMSList,

    listSummaryList,
    setListSummaryList,
    listSummaryError,
    setListSummaryError,
    listSummaryLoading,
    setListSummaryLoading,
    fetchListSummary
  }
}

export default ContactCenterController